export function filterToQuery(searchText: string): Record<string, string> {
    return { searchTerms: searchText };
}
interface IdObject {
    [key: string]: unknown;
    id?: string;
}

export function convertIdFilter<T extends IdObject>(filters: T): Omit<T, "id"> {
    const newFilters = { ...filters } as IdObject;

    // Replace id by uuid
    if (filters.id != null) {
        newFilters["uuid"] = filters.id;
        delete newFilters.id;
    }

    return newFilters as Omit<T, "id">;
}
